module.exports = __webpack_public_path__ + "static/image/history/m/201501@3x.ver2_0_2.jpg?72b14f11";